import React from 'react';

const challenges = [
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: 'Burocracia Excessiva',
    description: 'Processos lentos e complexos que dificultam a agilidade na tomada de decisões e na execução de projetos.',
    accent: 'blue',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    title: 'Falta de Transparência',
    description: 'Dificuldade em acompanhar o uso de recursos públicos e a prestação de contas, gerando desconfiança.',
    accent: 'orange',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" />
      </svg>
    ),
    title: 'Dados Descentralizados',
    description: 'Informações espalhadas em diferentes sistemas, dificultando a análise integrada e a visão estratégica.',
    accent: 'blue',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: 'Recursos Limitados',
    description: 'Orçamentos restritos exigem otimização e alocação eficiente para maximizar o impacto das ações.',
    accent: 'orange',
  },
];

const accentMap = {
  blue:   { icon: 'text-blue-800 bg-blue-50', border: 'border-gray-200' },
  orange: { icon: 'text-orange-600 bg-orange-50', border: 'border-gray-200' },
};

const DesafiosSection = () => (
  <section id="desafios" className="py-24 bg-gray-50">
    <div className="container mx-auto px-6 md:px-12">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2.5 mb-4 justify-center">
          <span className="w-1 h-4" style={{ background: '#F47920' }} />
          <span className="text-xs font-bold uppercase tracking-widest" style={{ color: '#F47920' }}>
            Os Desafios
          </span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight">
          Problemas reais da gestão pública
        </h2>
        <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
          Entendemos os obstáculos que gestores públicos enfrentam diariamente. A Nexus foi criada para resolver exatamente esses problemas.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {challenges.map((c, i) => {
          const a = accentMap[c.accent];
          return (
            <div
              key={i}
              className={`bg-white border ${a.border} rounded-xl p-6 hover:shadow-md transition-all duration-200 group`}
            >
              <div className={`inline-flex p-3 rounded-xl ${a.icon} mb-5 group-hover:scale-110 transition-transform duration-200`}>
                {c.icon}
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{c.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{c.description}</p>
            </div>
          );
        })}
      </div>

      {/* Bottom CTA strip */}
      <div className="mt-16 bg-white border border-gray-200 rounded-xl p-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <p className="text-lg font-bold text-gray-900">A Nexus resolve todos esses desafios.</p>
          <p className="text-gray-500 text-sm mt-1">Uma plataforma completa para modernizar sua gestão.</p>
        </div>
        <a
          href="#transformacao"
          onClick={e => { e.preventDefault(); document.querySelector('#transformacao')?.scrollIntoView({ behavior: 'smooth' }); }}
          className="flex-shrink-0 inline-flex items-center gap-2 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 shadow-sm text-sm"
          style={{ background: '#F47920' }}
          onMouseEnter={e => e.currentTarget.style.background = '#d96a10'}
          onMouseLeave={e => e.currentTarget.style.background = '#F47920'}
        >
          Ver a solução
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  </section>
);

export default DesafiosSection;
